import React, { useState, useEffect } from "react";
import chapters from "../../data/quran/chapters/en.json";
import ShowIcon from "../../assets/icons/view";
import HideIcon from "../../assets/icons/view-off";
import { QuranChapters } from "../../classes/QuranDataType";
import { AnimatePresence, motion } from "framer-motion";

interface SearchQuranProps {
  onSelectSurah: (surha: QuranChapters) => void;
  setShowTranslation: (value: boolean) => void;
  showTranslation: boolean;
  setShowTransliteration: (value: boolean) => void;
  showTransliteration: boolean;
  selectedSurah: QuranChapters | null;
}

const SearchQuran: React.FC<SearchQuranProps> = ({
  onSelectSurah,
  setShowTranslation,
  showTranslation,
  setShowTransliteration,
  showTransliteration,
  selectedSurah,
}) => {
  //   const [selectedSurah, setSelectedSurah] = useState<number | "">("");

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const surahNumber = parseInt(event.target.value, 10);
    // setSelectedSurah(surahNumber);
    const selected = chapters.find((surah) => surah.id === surahNumber);
    if (selected) {
      onSelectSurah(selected);
    }
  };

  return (
    <div className="w-full flex flex-col gap-4 px-6 bg-white rounded-[2.4em] py-6">
      <h2 className="font-grgrifter tracking-wider text-2xl text-[#AFAEB3] mb-4">
        Select Surah
      </h2>
      <div className="flex ">
        <select
          className="border p-2 rounded-xl bg-[#efedf4] w-full"
          value={selectedSurah ? selectedSurah.id : 0}
          onChange={handleChange}
        >
          <option value="">-- Choose a Surah --</option>
          {chapters.map((surah) => (
            <option key={surah.id} value={surah.id}>
              {surah.id}. {surah.transliteration} ({surah.total_verses})
            </option>
          ))}
        </select>
      </div>

      {/* bg-[#3A9437] */}

      <div className="flex justify-center gap-4 items-center">
        <button
          className="flex items-center justify-center py-2 rounded-[2em] cursor-pointer"
          type="submit"
          onClick={() => setShowTranslation(!showTranslation)}
        >
          <AnimatePresence mode="wait">
            {showTranslation ? (
              <motion.div
                key="show-icon"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.2, ease: "easeOut" }}
              >
                <ShowIcon size={18} className="mr-2" color="#3A9437" />
              </motion.div>
            ) : (
              <motion.div
                key="hide-icon"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0, ease: "easeOut" }}
              >
                <HideIcon size={18} className="mr-2" color="#3A9437" />
              </motion.div>
            )}
          </AnimatePresence>

          <p className="text-[0.8rem] tracking-wider text-left text-[#3A9437]">
            {showTranslation ? "Hide Translation" : "Show Translation"}
          </p>
        </button>
        <button
          className="flex items-center justify-center py-2 rounded-[2em] cursor-pointer transition-all duration-300 ease-in-out"
          type="submit"
          onClick={() => setShowTransliteration(!showTransliteration)}
        >
          {showTransliteration ? (
            <>
              <ShowIcon size={18} className="mr-2" color="#3A9437" />
              <p className="text-[0.8rem] tracking-wider text-left text-[#3A9437]">
                Hide Transliteration
              </p>
            </>
          ) : (
            <>
              <HideIcon size={18} className="mr-2" color="#3A9437" />
              <p className="text-[0.8rem] tracking-wider text-left text-[#3A9437]">
                Show Transliteration
              </p>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default SearchQuran;
